// userAuthTokenHeaderName should be available from
// an environment variable via config,
// but we don't have useRuntimeConfig yet.
const userAuthTokenHeaderName = 'x-user-token'
const userTokenStorageKey = 'userToken'

export function setUserToken(token: string) {
  if (typeof token !== 'string') {
    throw new TypeError(
      `setUserToken called with argument of type ${typeof token}.`
    )
  }
  sessionStorage.setItem(userTokenStorageKey, token)
}

export function removeUserToken() {
  if (sessionStorage) {
    sessionStorage.removeItem(userTokenStorageKey)
  }
}

function getUserToken() {
  const fn = '[services/apiClient.ts] getUserToken |'
  console.debug(`${fn} Getting user token.`)
  // @ts-ignore
  if (process.server) {
    // no session storage.
    console.log(`${fn} getUserToken invoked on server. Returning ''.`)
    return ''
  }

  const userToken =
    !!sessionStorage && sessionStorage.getItem(userTokenStorageKey)
  return userToken || ''
}

type UserAuthHeader = {
  [userAuthTokenHeaderName]?: string
}

export function userAuthHeader(): UserAuthHeader {
  // @ts-ignore
  if (process.server) {
    console.debug('userAuthHeader invoked on server.')
  }
  const userToken = getUserToken()
  return userToken ? { [userAuthTokenHeaderName]: userToken } : {}
}
